import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  fullWidth?: boolean;
  className?: string;
};

const FundDetailsTabRow = ({ children, fullWidth, className }: Props) => {
  return (
    <div className={`container ${className}`}>
      <div className="row">
        <div className={`col-12 ${!fullWidth ? 'col-lg-8' : ''}`}>{children}</div>
      </div>
    </div>
  );
};

export default FundDetailsTabRow;
